import { useState, useEffect } from 'react';
import { BellIcon, EnvelopeIcon } from '@heroicons/react/20/solid';
import EmailNotification from './email';
import AppPushNotification from './appPush';
import request from '../../../../../../lib/request';

const Notification = () => {
  const [notificationSetting, setNotificationSetting] = useState({
    email: false,
    appPush: false,
  });

  useEffect(() => {
    getNotificationStatus();
  }, []);

  const getNotificationStatus = async () => {
    try {
      const { result } = await request.get('/user/notification');

      if (result) {
        setNotificationSetting({
          email: result.email,
          appPush: result.appPush,
        });
      } else {
        setNotificationSetting({
          email: false,
          appPush: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h1 className='text-xl font-bold'>Notification</h1>
      <EmailNotification
        icon={<EnvelopeIcon className='size-4' />}
        notificationSetting={notificationSetting}
      />
      <AppPushNotification
        icon={<BellIcon className='size-4' />}
        notificationSetting={notificationSetting}
      />
    </div>
  );
};

export default Notification;
